<template>
    <CardPage :section="3" :page="6" :nextDisabled="nextDisabled">
        <FlipCard :flipped="flipped">
            <template v-slot:front>
                <p>
                    Click on each icon to read more about each area.
                </p>
                <v-layout row wrap justify-center my-3>
                    <v-flex xs6>
                        <div v-for="(key, index) in factsOrder" :key="index" @click.prevent="select(facts[key])" class="diagram-chip fact">
                            <v-chip :color="facts[key].color" text-color="white" class="py-2" v-ripple>{{ facts[key].title }}</v-chip>
                            <div class="check" v-if="facts[key].visited">
                                <v-avatar class="primary">
                                    <v-icon dark>check</v-icon>
                                </v-avatar>
                            </div>
                        </div>
                    </v-flex>
                </v-layout>
            </template>
            <template v-slot:back>
                <div v-if="selectedFact">
                    <p class="headline text-xs-center">{{ facts[selectedFact].title }}</p>
                    <p>{{ facts[selectedFact].text }}</p>
                    <div class="text-xs-center">
                        <v-btn round large color="primary" @click="done(facts[selectedFact])">Done</v-btn>
                    </div>
                </div>
            </template>
        </FlipCard>
        <template v-if="flipped" v-slot:actions>
            <v-spacer></v-spacer>
        </template>
    </CardPage>
</template>

<script>
import { get } from 'vuex-pathify';
import FlipCard from '@/components/FlipCard';

export default {
    components: { FlipCard },
    data() {
        return {
            flipped: false,
            selectedFact: null
        };
    },
    computed: {
        facts: get('section3/facts'),
        factsOrder: get('section3/factsOrder'),
        allFactsVisited: get('section3/allFactsVisited')
    },
    methods: {
        select(fact) {
            this.selectedFact = fact.id;
            this.flipped = true;
        },
        done(fact) {
            this.$store.set(`section3/facts@${fact.id}.visited`, true);
            this.flipped = false;
        },
        nextDisabled() {
            return !this.allFactsVisited || this.flipped;
        }
    }
};
</script>

<style scoped>
.fact {
    position: relative;
}
.check {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translate(-50%, -50%);
}
.visited {
    opacity: 0.5;
}
</style>
